import { Input, Output, Component, EventEmitter, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';

@Component({
    selector: 'tt-order-heads-grid',
    templateUrl: './order-heads-grid.component.html',
    styleUrls: ['./order-heads-grid.component.css'],
})
export class OrderHeadsGridComponent {
    @Input()
    public rememberId: string = 'w_orderheads_orderhead_grid';

    @Input()
    public params?: OrderHeadsGridParams;

    @Output()
    public gridReady = new EventEmitter<GridOptions>();

    public grid?: GridOptions;

    public readGrid() {
        if (!this.params) {
            console.warn('Projects grid needs parameters');
            return;
        }

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.rememberId).setLoadDataFunction({ method: 2852, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            if (this.validOrderHeadsGridParams(changes['params'].currentValue)) {
                this.readGrid();
            } else {
                console.error('Invalid orderheads grid parameters');
                console.dir(changes['params'].currentValue);
            }
        }
    }

    private validOrderHeadsGridParams(params: unknown): params is OrderHeadsGridParams {
        return !!params && typeof params === 'object';
    }
}

export interface OrderHeadsGridParams {
    /**
     * @default 1
     */
    page?: number;

    /**
     * @default 1000
     */
    pageSize?: number;

    /**
     * @default ''
     */
    argtype?: string;

    argvalue: string | number;

    /**
     * @default '99999'
     */
    businessco_no?: number | number;

    /**
     * @default '0'
     */
    cust_no?: string | number;

    /**
     * @default '0'
     */
    show_dateselector?: '1' | '0';

    /**
     * @default '1900-01-01'
     */
    date_fom?: string;

    /**
     * @default '2100-01-01'
     */
    date_tom?: string;

    /**
     * @default '1'
     */
    show_all_orders?: '1' | '0';

    /**
     * @default 'ALL'
     */
    gb_regby?: string;

    /**
     * @default 'ALL'
     */
    gb_ordertype?: string;

    /**
     * @default 'ORDERSTATUSALL'
     */
    gb_orderstatus?: string;

    /**
     * @default '1900-01-01'
     */
    gb_orderdate?: string;

    /**
     * @default '0'
     */
    reg_by_portal_user_keyno?: string | number;

    /**
     * @default '-'
     */
    orderstatus_id?: string;

    /**
     * @default '-'
     */
    ordertype_id?: string;

    /**
     * @default '0'
     */
    seller_id?: string | number;

    /**
     * @default ''
     */
    webpage?: string;

    /**
     * @default ''
     */
    ordersearch?: string;

    /**
     * @default ''
     */
    gb_orderheads_related?: string;

    webpage_name?: string;
}
